export default __webpack_public_path__ + "static/media/10.bc9641bd.png";